var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"vs-inputx vs-input--input normal hasValue",attrs:{"type":"text"},domProps:{"value":_vm.formattedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"keydown":_vm.checkDigit}})
}
var staticRenderFns = []

export { render, staticRenderFns }